module.exports = __webpack_public_path__ + "static/img/img11.534efcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img11.png
// module id = VmgM
// module chunks = 1